<ion-nav register #content [root]="rootPage"></ion-nav>
